import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { IntakeFormComponent } from './intake-form.component';

const routes: Routes = [{
  path: '',
  component: IntakeFormComponent,
  data: { preload: true }
}];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IntakeFormRoutingModule { }